import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import Uppy from 'uppy/lib/core';
import Transloadit from 'uppy/lib/plugins/Transloadit';
import DashboardModal from 'uppy/lib/react/DashboardModal';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import faCloudUploadAlt from '@fortawesome/fontawesome-free-solid/faCloudUploadAlt';
import 'uppy/dist/uppy.min.css';

import TransloaditKeys from '../../config/uploadKeys';
import { AttachmentType } from '../../config/constants';
import Button from './Button';

class AttachmentUploader extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isModalOpen: false,
      // Store uppy in state because it has bugs when unmounting in React if declared as a singleton
      uppy: Uppy({
        debug: process.env.NODE_ENV === 'development',
        autoProceed: false,
      })
        .use(Transloadit, {
          params: {
            auth: {
              // To avoid tampering use signatures:
              // https://transloadit.com/docs/api-docs/#authentication
              key: TransloaditKeys.AccountKey,
            },
            template_id:
              props.attType === AttachmentType.IMAGE
                ? TransloaditKeys.ImageUploadTemplateId
                : TransloaditKeys.FileUploadTemplateId,
          },
          waitForEncoding: true,
        })
        // .use(Uppy.Webcam, { target: Uppy.Dashboard })
        // .use(Uppy.Instagram, { target: Uppy.Dashboard, host: 'https://api2.transloadit.com/uppy-server' })
        .on('transloadit:complete', (assembly) => {
          const newAttachmentEntries = assembly.uploads.map(r => ({
            originalFileName: r.name,
            tempUploadName: r.ssl_url.replace(TransloaditKeys.S3BucketUrl, ''),
            type: props.attType,
            isMainAttachment: false,
          }));

          this.handleUpdate(newAttachmentEntries);

          setTimeout(() => {
            this.setState({ isModalOpen: false });
          }, 500);
        }),
    };
  }

  handleModalOpen = () => {
    this.setState({ isModalOpen: true });
  };

  handleModalClose = () => {
    this.setState({ isModalOpen: false });
  };

  handleUpdate = (newAttachmentEntries) => {
    this.props.onSuccess(newAttachmentEntries);
  };

  render() {
    const { buttonLabel, buttonColor } = this.props;

    const label = buttonLabel ? (
      <React.Fragment>
        <span className="icon">
          <FontAwesomeIcon icon={faCloudUploadAlt} className="icon" />
        </span>
        <span>{buttonLabel}</span>
      </React.Fragment>
    ) : (
      <FontAwesomeIcon icon={faCloudUploadAlt} className="icon" />
    );

    return (
      <div>
        <Button
          label={label}
          color={buttonColor}
          handler={this.handleModalOpen}
          id="uppy-open-modal"
          className={`uploadButton ${this.props.buttonClassName}`}
        />
        <DashboardModal
          uppy={this.state.uppy}
          open={this.state.isModalOpen}
          closeModalOnClickOutside
          onRequestClose={this.handleModalClose}
          proudlyDisplayPoweredByUppy={false}
        />
      </div>
    );
  }
}

AttachmentUploader.propTypes = {
  attType: PropTypes.oneOf(_.keys(AttachmentType)).isRequired,
  buttonLabel: PropTypes.string,
  buttonColor: PropTypes.string,
  buttonClassName: PropTypes.string,
  onSuccess: PropTypes.func.isRequired,
};

AttachmentUploader.defaultProps = {
  buttonLabel: '',
  buttonColor: 'link',
  buttonClassName: 'is-outlined',
};

export default AttachmentUploader;



// WEBPACK FOOTER //
// ./src/components/common/AttachmentUploader.jsx